import React, { useState } from "react";
import { GoogleMap, LoadScript, Marker, Polyline } from "@react-google-maps/api";
import globalConfig from "../../../../../../configs/globalConfigs";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  mapTypeId: "roadmap",
  streetViewControl: false,
  fullscreenControl: false,
};

const colors = ["#FF0000", "#0000FF", "#00FF00", "#FFA500", "#800080"];

export default function MapRota({ coords = [] }) {
  const [routes, setRoutes] = useState([]);
  const [mapLoaded, setMapLoaded] = useState(false);

  const onMapLoad = (map) => {
    setMapLoaded(true);

    if (!coords || coords.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();
    const newRoutes = [];

    for (let i = 0; i < coords.length; i += 2) {
      const origin = coords[i];
      const destination = coords[i + 1];
      if (!origin || !destination) continue;

      directionsService.route(
        {
          origin,
          destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            const path = result.routes[0].overview_path.map((p) => ({
              lat: p.lat(),
              lng: p.lng(),
            }));
            setRoutes((prev) => [...prev, { path, color: colors[prev.length % colors.length] }]);
          } else {
            console.error("Directions request failed:", status);
          }
        }
      );
    }
  };

  if (!coords || coords.length === 0) {
    return <div style={{ padding: 20 }}>Nenhuma coordenada recebida</div>;
  }

  return (
    <LoadScript googleMapsApiKey={globalConfig.mapKey} libraries={["places"]}>
      <GoogleMap
        center={coords[0]}
        zoom={8}
        mapContainerStyle={containerStyle}
        options={mapOptions}
        onLoad={onMapLoad}
      >
        {/* Marcadores */}
        {coords.map((coord, idx) => (
          <Marker key={idx} position={coord} />
        ))}

        {/* Rotas */}
        {routes.map((route, idx) => (
          <Polyline
            key={idx}
            path={route.path}
            options={{
              strokeColor: route.color,
              strokeOpacity: 0.8,
              strokeWeight: 4,
            }}
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
}
